import script from "./MAutocomplete.vue?vue&type=script&setup=true&lang=js"
export * from "./MAutocomplete.vue?vue&type=script&setup=true&lang=js"

import "./MAutocomplete.vue?vue&type=style&index=0&id=24230a94&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24230a94"]])

export default __exports__